module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAtBAMAAAA0IdRjAAAAIVBMVEVHcEyZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZnOMdpLAAAACnRSTlMAxeoXg6yWLUZtIfRPygAAASZJREFUKM91kj1LA0EQhuc8L6ddMKBylSJB2MpIKishYmEVUslVEQQh1WkhaKWCTSo766xeDO+vdO92Zz/IZpqZe/aYeeeDSNvLHo6/ybd3NHbokQ6wf3UHTC1JCzlSbigWZ4wS9Fo/QJfRrDZBuTTBjn1M8GYCySlSYR5ff22hmz/jfyy6MK+FrUPJQnvhFHak9ri0aBsbkRhblMmN6SMiIlIjDUXajgwnNsLIoCPrIPpYW9pnS3DryCPQv7+eAAdMdiEfGv8s8MVqMNLBEEZghlP+/wl6TjOnJi2WOlPPFRq02c6lk6xGcdIkX/mHNlcFcox9lKFS7VU+ylWfW3VwoVQe0XwVIvXtrYd3VHZDlNT+qnnfYhoidTvejfChTKoQ5X1at3/84lr8kgy9/wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person.png
// module id = VFY2
// module chunks = 0